import React, {useState} from 'react';
import {Alert, Button, Card, Form, Modal} from 'react-bootstrap';

const MAX_LENGTH = 2000;

const CommentCard = ({isAlerted, onAlert}) => {
    const [comment, setComment] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [feedback, setFeedback] = useState(null);

    const trimmed = comment.trim();
    const canSubmit = !isAlerted && trimmed.length > 0 && trimmed.length <= MAX_LENGTH && !submitting;

    const handleConfirm = async () => {
        setShowConfirm(false);
        setSubmitting(true);
        const result = await onAlert({comment: trimmed});
        setSubmitting(false);
        if (!result?.ok) {
            setFeedback({ok: false, status: result?.status});
        }
    };

    return (
        <>
            <Card className="mb-4">
                <Card.Header>Signaler un problème</Card.Header>
                <Card.Body>
                    <p className="text-muted small mb-3">
                        Ajouter un commentaire uniquement pour signaler une erreur
                        d&apos;interprétation de votre dossier à l&apos;équipe tiers payant.
                    </p>
                    {feedback && !feedback.ok && (
                        <Alert variant="danger">
                            {feedback.status === 409
                                ? 'Un signalement est déjà en cours sur ce dossier.'
                                : 'Une erreur est survenue. Réessayez plus tard.'}
                        </Alert>
                    )}

                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        maxLength={MAX_LENGTH}
                        disabled={isAlerted}
                        placeholder="Décrivez le problème rencontré sur ce dossier"
                    />
                    <div className="d-flex justify-content-end mt-2">
                        <Button
                            variant="danger"
                            disabled={!canSubmit}
                            onClick={() => setShowConfirm(true)}
                        >
                            {submitting ? 'Envoi…' : 'Envoyer signalement'}
                        </Button>
                    </div>
                </Card.Body>
            </Card>

            <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer le signalement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Vous allez signaler un problème bloquant sur ce dossier. Notre équipe sera
                    notifiée et vous ne pourrez plus modifier la facture tant que le signalement
                    n&apos;est pas traité. Confirmer ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>Annuler</Button>
                    <Button variant="danger" onClick={handleConfirm}>Confirmer le signalement</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CommentCard;
